export default "__VITE_ASSET__C_kKq7RL__"